import React, { useContext, useEffect, useState } from 'react'
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import './scrollTopButton.scss'

const SHOW_AFTER = 480 // px scrolled before the button appears

/**
 * Round "back to top" arrow in the bottom-right corner of every page. Hidden
 * at the top of the page, it appears once the visitor has scrolled down and
 * brings them back up smoothly (instantly for reduced motion).
 *
 * It sits above the conversion bar whenever that bar is on screen — the bar
 * publishes its height as the --cbar-offset CSS variable.
 */
const ScrollTopButton = () => {
  const { translations: t } = useContext(LanguageContext)
  const reduced = useReducedMotion()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const toTop = () => window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' })

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type='button'
          className='scroll-top-btn'
          onClick={toTop}
          aria-label={t.uiBackToTop || 'Back to top'}
          initial={reduced ? false : { opacity: 0, y: 16, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={reduced ? { opacity: 0 } : { opacity: 0, y: 16, scale: 0.9 }}
          transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
        >
          <svg width='20' height='20' viewBox='0 0 20 20' aria-hidden='true' focusable='false'>
            <path d='M10 15.5V4.5M4.5 10 10 4.5 15.5 10' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </motion.button>
      )}
    </AnimatePresence>
  )
}

export default ScrollTopButton
